import axios from 'axios';
import router from "@/router";
import ACTION_TYPES from "./action-types";
import MUTATION_TYPES from "./mutation-types";

export default {
    namespaced: true,
    state: {
        authenticated: false,
        user: {
            roles: [],
            permissions: [],
        },
        roles: {}, // All roles, not just those of the current user
        permissions: {}, // All permissions, not just those of the current user
        routes: {
            login_successful: 'dashboard.home',
        },
        nav_items : []
    },
    getters: {
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user
        },
    },
    mutations: {
        [MUTATION_TYPES.SET_AUTHENTICATED](state, value) {
            state.authenticated = value
        },
        [MUTATION_TYPES.SET_USER](state, value) {
            state.user = value
        },
        [MUTATION_TYPES.SET_ROLES](state, value) {
            state.roles = value
        },
        [MUTATION_TYPES.SET_PERMISSIONS](state, value) {
            state.permissions = value
        },
        [MUTATION_TYPES.SET_NAV_ITEMS](state, value) {
            state.nav_items = value;
        },
    },
    actions: {
        [ACTION_TYPES.LOGIN.NAME]({ commit, state, dispatch }) {
            return new Promise((resolvePromise, rejectPromise) => {
                axios.get('/api/user')
                    .then(({ data }) => {
                        commit(MUTATION_TYPES.SET_USER, data);
                        commit(MUTATION_TYPES.SET_AUTHENTICATED, true);

                        axios.get('/api/roles-permissions/all')
                            .then(({ data }) => {
                                commit(MUTATION_TYPES.SET_ROLES, data.roles);
                                commit(MUTATION_TYPES.SET_PERMISSIONS, data.permissions);
                                commit(MUTATION_TYPES.SET_NAV_ITEMS, [
                                    { title: 'FAQs', icon: 'mdi-frequently-asked-questions', link: {name: 'dashboard.faqs'}, permission: state.permissions.FAQ_READ_WEB.name },
                                    { title: 'Forms', icon: 'mdi-format-list-checkbox', link: {name: 'dashboard.forms'}, permission: state.permissions.FORM_READ_WEB.name  },
                                    { title: 'Orders', icon: 'mdi-basket', link: {name: 'dashboard.orders.index'}, permission: state.permissions.ORDER_READ_WEB.name  },
                                    { title: 'Products', icon: 'mdi-basket', link: {name: 'dashboard.products.index'}, permission: state.permissions.PRODUCT_READ_WEB.name  },
                                    { title: 'Collections', icon: 'mdi-basket', link: {name: 'dashboard.collections.index'}, permission: state.permissions.COLLECTION_READ_WEB.name  },
                                    { title: 'Events', icon: 'mdi-text-box-outline', link: {name: 'dashboard.events.index'}, permission: state.permissions.EVENT_READ_WEB.name  },
                                    { title: 'Errors', icon: 'mdi-alert', link: {name: 'dashboard.errors.index'}, permission: state.permissions.ERROR_READ_WEB.name  },
                                    { title: 'Stats', icon: 'mdi-file-excel-box', link: {name: 'dashboard.stats.index'}, permission: state.permissions.STATS_READ_WEB.name  },
                                    { title: 'Javra Viewer', icon: 'mdi-cloud-braces', link: {name: 'dashboard.javra.index'}, permission: state.permissions.JAVRA_READ_WEB.name  },
                                ]);
                            });

                        resolvePromise();
                    })
                    .catch(() => {
                        rejectPromise();
                        dispatch(ACTION_TYPES.LOGOUT.NAME);
                    });
            });
        },
        /**
         * A 401 here is handled by the axios interceptor, which logs the user out.
         * Other failures are ignored so a server hiccup doesn't end a valid session.
         */
        [ACTION_TYPES.VERIFY_SESSION.NAME]({ commit }) {
            return axios.get('/api/user')
                .then(({ data }) => {
                    commit(MUTATION_TYPES.SET_USER, data);
                })
                .catch(() => {});
        },
        [ACTION_TYPES.LOGOUT.NAME]({ commit }) {
            commit(MUTATION_TYPES.SET_USER, {});
            commit(MUTATION_TYPES.SET_AUTHENTICATED, false);
            router.push({
                name: 'auth.login',
            });
        },
    },
};
